import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  message,
  Row,
  Space,
  Table,
  notification,
  Tooltip,
  Switch,
  Modal,
  Input,
  Form,
} from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { FaSliders } from "react-icons/fa6";
import IMAGES from "../../../const/Image";
import { components, getRowClassName } from "../../../utils/utils";
import vendorRequest from "../VendorRequest";
import { VendorFilter } from "./VendorFilter";
import { AddVendorAmount } from "./AddVendorAmount";
import { FileTextOutlined } from "@ant-design/icons";

const { confirm } = Modal;

const initialFilter = {
  page: 1,
};

export const Vendors = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddVendorAmountOpen, setIsAddVendorAmountOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const navigate = useNavigate();

  // Fetch filtered users list
  const fetchUserFilterList = () => {
    setLoading(true);
    vendorRequest
      .userFilteredList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        const totalCount = response?.data?.total || 0;
        setLabList(rawData);
        setFilteredUsers(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch users.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUserFilterList();
  }, [filter]);


   const handleLeisureChanhge = () => {

    fetchUserFilterList();
   }
  // Handle search filter
  const handleFilter = () => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    setIsModalOpen(false);
  };

  // Handle pagination changes
  const handleChange = (pagination) => {
    setFilter({ ...filter, page: pagination?.current });
  };

  // Reset filters to initial state
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Handle Add Vendor Amount modal
  const handleAddVendorAmountClick = (vendor) => {
    setSelectedVendor(vendor);
    setIsAddVendorAmountOpen(true);
  };

  const handleAddVendorAmountCancel = () => {
    setIsAddVendorAmountOpen(false);
    setSelectedVendor(null);
  };

  // Columns configuration for the Table
  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Wallet Amount",
      dataIndex: "walletAmt",
      key: "walletAmt",
    },
    {
      title: "Document",
      dataIndex: "fileName",
      key: "fileName",
      render: (text, record) => {
        return record.fileName?.trim() ? (
          <a
            href={record.fileName}
            style={{ color: "#1890ff", display: "flex", alignItems: "center", gap: 6 }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FileTextOutlined />
            View
          </a>
        ) : (
          text
        );
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      width: 120,
      align: "center",
      render: (isActive, item) => (
        <Switch
          checked={isActive}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Add Money">
            <PlusOutlined
              style={{ cursor: "pointer" }}
              onClick={() => handleAddVendorAmountClick(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Handle status change (active/inactive)
  const handleStatusChange = (checked, item) => {
    if (!item.id) {
      notification.error({
        message: "User ID is required to update status.",
      });
      return;
    }
    // Uncomment and implement status change functionality if needed
  };

  return (
    <>
      <div>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Vendors List</h1>
          </Col>
          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Button
                onClick={() => showModal()}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <FaSliders />
              </Button>
              <Button
                onClick={resetFilters}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                Reset
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredUsers}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1,
          }}
        />
      </div>
      <VendorFilter
        handleFilter={handleFilter}
        form={form}
        filterForm={filterForm}
        setFilterForm={setFilterForm}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
      />
      {isAddVendorAmountOpen && (
        <AddVendorAmount
          form={form}
          isModalOpen={isAddVendorAmountOpen}
          handleCancel={handleAddVendorAmountCancel}
          // setFilterForm={setFilterForm}
          // filterForm={filterForm}
          handleFilter={handleFilter}
          hndl={handleLeisureChanhge}
          tableData={filteredUsers}
          availableBalance={selectedVendor?.walletAmt || 0}
          vendorId={selectedVendor?.id} // Pass the vendor ID
          handleAddMoney={(values) => {
            console.log("Add Money for Vendor:", selectedVendor, values);
            handleAddVendorAmountCancel();
          }}
        />
      )}
    </>
  );
};